<template>
  <div class="layout isBigView" :class="{ isInIframe: isInIframe }">
    <!--header-->
    <header class="pageHeader">
      <div class="logo flex-center">
        <img src="@/assets/logo.png" />
        <span>
          <font>万知达优选专利</font>
        </span>
      </div>
      <ul class="modelList">
        <!--登录前购物车-->
        <li class="li QHTaskMsg" v-if="$isblank($store.state.user)" @click="$refs.QHaccountEenter.hello('QHlogin')">
          <div class="flex-center">
            <i class="iconfont icon-gouwuche flex-center" style="font-size: 20px; font-weight: normal; margin-right: 5"></i>
            <span>购物车</span>
            <span class="CL5" style="font-size: 14px; font-weight: 700">(请登录)</span>
          </div>
        </li>
        <!--登录前购物车 end-->

        <!--登录后购物车-->
        <li class="li QHTaskMsg" v-if="!$isblank($store.state.user)" @click="$QHopenUrlIsLogin('/car')">
          <div class="flex-center">
            <i class="iconfont icon-gouwuche flex-center" style="font-size: 20px; font-weight: normal; margin-right: 5"></i>
            <span>购物车</span>
            <span class="CL5" style="font-size: 16px; font-weight: 700">({{ $store.state.carCount.isGuanzhuNum || 0 }})</span>
          </div>
        </li>
        <!--登录后购物车 end-->
        <li class="li QHTaskMsg" v-if="!$isblank($store.state.user)" @click="$refs.OskefuCG.hello()">
          <div class="flex-center">
            <i class="iconfont icon-qiyeduxiang flex-center" style="font-size: 20px; font-weight: normal; margin-right: 5"></i>
            <span>联系客服</span>
          </div>
        </li>
      </ul>

      <!--登录前-->
      <div class="userInfo" @click="$refs.QHaccountEenter.hello('QHlogin')" v-if="$isblank($store.state.user)">
        <a href="javascript:void(0)" class="flex-center">
          <img src="../../style/images/face.png" />
          <span>立即登录</span>
        </a>
      </div>
      <!--登录前 end-->

      <!--登录后-->
      <Dropdown class="userInfo" trigger="click" v-if="!$isblank($store.state.user)">
        <a href="javascript:void(0)" class="flex-center">
          <img src="../../style/images/face.png" />
          <span>{{ $store.state.user.account }}</span>
          <Icon type="md-arrow-dropdown" />
        </a>
        <DropdownMenu slot="list">
          <DropdownItem>
            <p @click="rePassword()">修改密码</p>
          </DropdownItem>
          <DropdownItem>
            <p @click="$loginOut()">退出登录</p>
          </DropdownItem>
        </DropdownMenu>
      </Dropdown>
      <!--登录后 end-->
    </header>
    <!--header end-->

    <!--状态切换区-->
    <div class="pageTab">
      <Icon type="md-apps" class="bigsizeToogleBtn" size="25" />
      <slot name="pageTab"></slot>
    </div>
    <!--状态切换区 end-->

    <!--搜索及功能区-->
    <div class="pageSearch" v-if="$slots.pageSearch && $slots.pageSearch.length">
      <slot name="pageSearch"></slot>
    </div>
    <!--搜索及功能区 end-->

    <!--主体呈现区-->
    <div class="pageContent" v-watermark="watermark()">
      <slot name="pageContent"></slot>
    </div>
    <!--主体呈现区 end-->

    <!--弹窗组件区-->
    <div class="pageBlock" v-if="$slots.pageBlock && $slots.pageBlock.length">
      <slot name="pageBlock"></slot>
    </div>
    <!--弹窗组件区 end-->

    <!--密码修改-->
    <updatePassword ref="updatePassword" @success="$refs.QHaccountEenter.hello('QHlogin')"></updatePassword>

    <!--登录组件-->
    <QHaccountEenter ref="QHaccountEenter"></QHaccountEenter> that.$getMYguanzhuzhuanli();
    <OskefuCG ref="OskefuCG"></OskefuCG>
  </div>
</template>

<script>
import updatePassword from "./block/updatePassword";
import OskefuCG from "@/components/OskefuCG/OskefuCG";
export default {
  components: {
    updatePassword,
    OskefuCG,
  },
  data() {
    return {
      Dev: 0,
      user: this.$getLocalStorage("nowUserGobal"),
      isInIframe: true,
    };
  },
  mounted() {
    //是否是iframe模式
    var that = this;
    this.isInIframe = this.$checkIfInIframe();

    //刷新登录信息
    this.$getNowUserGobal(this);
  },
  methods: {
    // +----------------------------------------------------------------------
    // | Desc:helloLoginPop
    // +----------------------------------------------------------------------
    helloLoginPop() {
      this.$refs.QHaccountEenter.hello("QHlogin");
    },

    // +----------------------------------------------------------------------
    // | Desc:rePassword
    // +----------------------------------------------------------------------
    rePassword() {
      this.$refs.updatePassword.hiUpdete();
    },

    // +----------------------------------------------------------------------
    // | Desc:detailed
    // +----------------------------------------------------------------------
    detailed() {
      this.$refs.detailed.hiPop();
    },

    // +----------------------------------------------------------------------
    // | Desc:水印生成
    // +----------------------------------------------------------------------
    watermark() {
      if (this.$isblank(this.user)) {
        var text = "@万至达专利";
      } else {
        var text = "@万至达专利ID" + this.user.id;
      }
      var text = text + this.$getNowDate();
      var watermark = { text: text, color: "rgba(0,0,0,0.08)", size: 16 };
      return watermark;
    },
  },
};
</script>
